// extracted by mini-css-extract-plugin
export default {"container":"Gf86624","description":"G763efe"};